var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('de-container',{staticStyle:{"background-color":"#f7f8fa"}},[_c('de-main-container',{class:{ 'full-height': _vm.fullHeightFlag }},[_c('panel-edit')],1)],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }